/**
 * User role constants - Flat permission system (no hierarchy)
 */

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  ENGINEER: 'engineer',
  OPERATIONS: 'operations',
  EDITOR: 'editor',
  AUTHOR: 'author',
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

export const SECTIONS = [
  'account',
  'publications', 
  'comments',
  'media',
  'operations',
  'users',
  'memberships',
  'pages',
  'communications',
  'intelligence',
  'settings'
] as const;

export type Section = typeof SECTIONS[number];

// Default fallback permissions (in case DB is unreachable)
export const DEFAULT_PERMISSIONS: Record<UserRole, Section[]> = {
  super_admin: [...SECTIONS],
  admin: ['account', 'publications', 'comments', 'media', 'operations', 'users', 'memberships', 'pages', 'communications', 'intelligence', 'settings'],
  engineer: ['account', 'operations', 'intelligence'],
  operations: ['account', 'operations', 'users', 'memberships', 'communications'],
  editor: ['account', 'publications', 'comments', 'media', 'operations'],
  author: ['account', 'publications', 'comments', 'media'],
};

// Role display labels for UI
export const ROLE_LABELS: Record<UserRole, string> = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  engineer: 'Engineer',
  operations: 'Operations',
  editor: 'Editor',
  author: 'Author',
};

// Section display labels for UI
export const SECTION_LABELS: Record<Section, string> = {
  account: 'Account',
  publications: 'Publications',
  comments: 'Comments',
  media: 'Media',
  operations: 'Operations',
  users: 'Users',
  memberships: 'Memberships',
  pages: 'Pages',
  communications: 'Communications',
  intelligence: 'Intelligence',
  settings: 'Settings',
};
